// extracted by mini-css-extract-plugin
export default {"tag":"Tag-index__tag--QIJA8"};